import React from 'react';



const PaymentItem = ({ payment }) => {

    const config = window.APP_CONFIG;

    const paymentDetails = {
        'نقدی': {

            color: 'rgba(121,64,239,0.53)',
        },
        'کیف پول': {

            color: 'rgba(26,130,251,0.53)',
        },
        'آنلاین': {

            color: 'rgb(0,129,66)',
        },
    };

    const details = paymentDetails[payment.type] || paymentDetails['نقدی'];

    return (
        <div className="payment-item my-3 rounded" style={{ '--payment-color': details.color }}>

            <div className="payment-details">
                <span className="payment-type">{payment.type}</span>
                <span className="payment-date">{payment.date}</span>
            </div>
            <div className="payment-amount">
                {payment.amount.toLocaleString('fa-IR')}
                {" "}
               ریال
            </div>
        </div>
    );
};

const PaymentHistory = ({ payments }) => {
    if (!payments || payments.length === 0) {
        return <div className="no-payments">پرداختی ثبت نشده است.</div>;
    }

    return (
        <div className="payment-history-container">
            <h3>تاریخچه پرداخت‌ها</h3>
            {payments.map((payment, index) => (
                <PaymentItem key={index} payment={payment} />
            ))}
        </div>
    );
};

export default PaymentHistory;
